import React from 'react';
import Container from 'Nori/Container';
import Card from 'Custom/Card';
import styles from 'Custom/EnrollmentCards/index.module.scss';

const EnrollmentCards = ({
  className = '',
  title = '',
  cards = [],
  children,
  ...props
}) => (
  <div className={`${styles.enrollmentWrapper} ${className}`} {...props}>
    <Container className={styles.cardsContainer}>
      {title && <h2 className={styles.sectionTitle}>{title}</h2>}

      {Boolean(cards.length) && (
        <div className={styles.cardList}>
          {cards.map((card, index) => (
            <Card
              key={`card-${index}`}
              type="enrollment"
              className={styles.cardItem}
              {...card}
            />
          ))}
        </div>
      )}
    </Container>
  </div>
);

export default EnrollmentCards;
